// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'babel-polyfill'
import Vue from 'vue'
import App from './App'
import router from './router'
import store from "./store";
import VueLazyload from 'vue-lazyload'
Vue.use(VueLazyload, {
  preLoad: 1.3,
  error: 'https://www1.pcauto.com.cn/test/gz20200018/jizhi/img/loading.png',
  loading: 'https://www1.pcauto.com.cn/test/gz20200018/jizhi/img/loading.png',
  attempt: 1
})
// import ElementUI from 'element-ui';
// import 'element-ui/lib/theme-chalk/index.css';
// Vue.use(ElementUI);
import {Collapse,CollapseItem,Progress,Dialog} from 'element-ui';
Vue.use(CollapseItem)
Vue.use(Collapse)
Vue.use(Progress)
Vue.use(Dialog)
import {app, rem, request} from './lib';
import '@/common/autoScale.js'
import '@/common/common.css'
import axios from 'axios'
//让ajax携带cookie
axios.defaults.withCredentials=true;
Vue.prototype.$store = store;
Vue.prototype.$axios = request;
Vue.config.productionTip = false
Vue.prototype.$app = app;
//载入commonjs
import commonjs from '@/common/common.js'
Vue.prototype.commonjs = commonjs;
/* eslint-disable no-new */

new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js